import React from 'react';
import styled from 'styled-components';
import '../assets/css/styles.css'
import { Draggable } from 'react-beautiful-dnd';
import ordinal_suffix_of from '../components/Ordinal';
import returnJSX from '../components/ReturnJSX';


const Container = styled.div`
  width:78vw;
  display:flex;
  justify-content:space-between;
  align-items:stretch;
  margin-left:auto;
  margin-right:auto;
  margin-bottom: 28px;
  background: #E5E5E5;
  color:#000;
  font-family:UbuntuMedium;
  font-size:14px;
  line-height:32px;
  align-items:center;
;
`;

export default class Task extends React.Component {
  render() {
    return (
      <Draggable draggableId={this.props.task.sid} index={this.props.index} >
        {provided => (
        
          <Container
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            ref={provided.innerRef}
          >
          <div className="choice-order-number"><h3>{ordinal_suffix_of(this.props.index+1)}</h3></div>
            <span className="details-txt">{returnJSX(this.props.task.description)}</span>
            <div className="arrows-col"><a href="#" className=""><i className="fa fa-arrows-alt"></i></a>
            </div>
          </Container>
        )}
      </Draggable>
    );
  }
}
